<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-number"><a href="#/Text/Contents#pro"><span class="blue">PROLOGUE</span></a></p>
<p class="flush-left-opener">Everything is ready now.</p>
<p class="indented">Each morning for seven weeks I have swept the fallen leaves from the stone slabs that form the path to the teahouse, and forty-nine times I have chosen a handful among them to be scattered on the stones again, so the path wouldn’t look too much like it had been swept. That was one of the things my father always insisted on.</p>
<p class="indented">Sanja told me once the dead don’t need pleasing. Perhaps they don’t. Perhaps I do. Sometimes I don’t know the difference. How could I, when they are in my blood and bones, when all that is left of them is me?</p>
<p class="indented">I haven’t dared to go to the spring in seven weeks. Yesterday I turned on the tap in the house and held the mouth of the waterskin to its metal. I spoke to it in pretty words and ugly words, and I may have even screamed and wept, but water doesn’t care for human sorrows. It flows without slowing or quickening its pace in the darkness of the earth, where only stones will hear.</p>
<p class="indented">The pipe gave a few drops, perhaps a spoonful, into my waterskin.</p>
<p class="indented">I know what it means.</p>
<p class="indented">This morning I emptied the rest of the water from the skin into the cauldron, brought some dried peat from the shed into the teahouse and placed the firestarter next to the hearth. I thought of my father, whose wishes I had violated, and my mother, who didn’t see the day I became a tea master.</p>
<p class="indented">I thought of Sanja. I hoped she was already where I was going.</p>
<p class="indented">A guest whose face is not unfamiliar is walking down the path, offering me a hand I’m ready to take. The world will not spin slower or faster when we have passed through the gate together.</p>
<p class="indented">What remains is light on water, or a shifting shadow.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?4b965b0f